import { render } from "./AllUser.vue?vue&type=template&id=a60bd414&scoped=true&class=relative%20bg-gray-200"
import script from "./AllUser.vue?vue&type=script&lang=js"
export * from "./AllUser.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a60bd414"

export default script